<template>
    <div>
        <div class="help-block">{{$t("Sisesta kuulutuse sisu")}}</div>

        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="ad-cat">
                        {{$t('Rubriik')}}
                        <span class="fas fa-info-circle" v-b-popover.hover.bottom="$t('popover rubriik')"></span>
                    </label>
                    
                    <select @change="saveState" class="form-control" v-model="category">
                        <option :value="cat" id="ad-cat" v-for="cat in categories">
                            {{cat['name'][!adid?$i18n.locale:'et']}}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="ad-content">
                        {{$t('Kuulutuse sisu')}}
                        <span class="fas fa-info-circle" v-b-popover.hover.bottom="$t('popover kuulutuse sisu')"></span>
                    </label>
                    
                    <span>
                        <span @click="addChar('–')"> | – | </span>
                        <span @click="addChar('×')"> × | </span>
                        <span @click="addChar('²')"> ² | </span>
                        <span @click="addChar('³')"> ³ | </span>
                        <span @click="addChar('\xA0')"> &nbsp; |</span>
                    </span>
                    <div v-if="adid">
                        <QuillEditor 
                            :editorOptions="editorOptions"
                            :toolbar="customToolbar"
                            :formats="allowedFormats"
                            content-type="html"
                            @blur="setQuillCursorLocation()"
                            @focus="setQuillCursorLocation()"
                            @selectionChange="setQuillCursorLocation()"
                            @textChange="setQuillCursorLocation()"
                            ref="quillEditor"
                            v-model:content="adContent"
                        ></QuillEditor>
                        <div class="input-group-addon" v-text="(500 - adContent.length)"></div>
                    </div>
                    <div v-else>
                    <textarea :maxlength="500" class="form-control" id="ad-content" ref="textAdContent"
                              v-model="adContent"></textarea>
                        <div class="input-group-addon" v-text="(500 - adContent.length)"></div>
                    </div>
                </div>
                <div class="form-group custom-control custom-checkbox vertical-margin z-0">
                    <input @change="changed('frame')" class="custom-control-input" id="ad-frame"
                           type="checkbox"
                           v-model="hasFrame">
                    <label class="custom-control-label w-100" for="ad-frame">
                        {{$t('Raam')}}
                        <span class="fas fa-info-circle" v-b-popover.hover.bottom="$t('popover raam')"></span>
                    </label>
                </div>
                <div class="form-group custom-control custom-checkbox vertical-margin z-0">
                    <input @change="changed('background')" class="custom-control-input" id="ad-background"
                           type="checkbox" v-model="hasBackground">
                    <label class="custom-control-label w-100" for="ad-background">
                        {{$t('Taust')}}
                        <span class="fas fa-info-circle" v-b-popover.hover.bottom="$t('popover taust')"></span>
                    </label>
                </div>
                <div class="form-group custom-control custom-checkbox vertical-margin z-0">
                    <input @change="changed('image')" class="custom-control-input" id="ad-image"
                           type="checkbox"
                           v-model="hasImage">
                    <label class="custom-control-label w-100" for="ad-image">
                        {{$t('Pilt')}}
                        <span class="fas fa-info-circle" v-b-popover.hover.bottom="$t('popover pilt')"></span>
                    </label>
                </div>
                <div v-if="hasImage">
                    <div class="form-group z-0">
                        <input 
                            ref="fileInput"
                            type="file" 
                            accept="image/*" 
                            @change="onFileChosen" 
                            class="form-control d-none" 
                        />
                        <input :value="$t('Lae pilt oma arvutist')" @click="fileInput.click()"
                               class="form-control"
                               readonly/>
                    </div>
                </div>

                <div v-if="!adid && Object.keys(translationNeeds).length > 0">
                    <div class="form-group custom-control custom-checkbox vertical-margin">
                        <input @change="changed" class="custom-control-input" id="wantTranslation"
                               type="checkbox" v-model="wantTranslation">
                        <label class="custom-control-label" for="wantTranslation">
                            {{$t('Telli tolge')}}
                            <span class="fas fa-info-circle" v-b-popover.hover.bottom="$t('popover tellitolge')"></span>
                        </label>
                    </div>

                    <div v-for="(need, index) in translationNeeds" v-if="!wantTranslation">
                        <label class="realbold mt-2">{{$t(need)}}</label>
                        <textarea :id="'translation_' + index" :maxlength="adid?9999:500" class="form-control"
                                  v-model="translations[index]"></textarea>
                        <div class="input-group-addon" v-text="(500 - (translations[index]).length)"></div>
                    </div>
                </div>

                <div v-if="adid">
                    <div class="form-group custom-control custom-checkbox vertical-margin">
                        <input @change="changed" class="custom-control-input" id="wantTranslationAdmin"
                               type="checkbox" v-model="wantTranslation">
                        <label class="custom-control-label" for="wantTranslationAdmin">
                            {{$t('Telli tolge')}}
                            <span class="fas fa-info-circle" v-b-popover.hover.bottom="$t('popover tellitolge')"></span>
                        </label>
                       
                    </div>

                    <div v-for="(need, index) in translations">
                        <label class="realbold mt-2">Tõlge {{getTranslationName(index)}}</label>
                        <textarea :id="'translation_' + index" :maxlength="adid?99999:500" class="form-control"
                                  v-model="translations[index]"></textarea>
                        <div class="input-group-addon" v-text="(500 - String(translations[index]).length)"></div>
                    </div>
                </div>
            </div>

            <div class="offset-md-1 col-md-5 col-sm-8 offset-sm-2">
                <div class="preview" v-bind:class="previewClasses">
                    <div>
                        <MyCropper
                            :visible="Boolean(hasImage && imgUrl!=null && !adid)"
                            :image-content="imageContent"
                            :callback="cropperCallback"
                        />
                    </div>
                    <div v-show="hasImage && imgUrl!=null &&adid">
                        <img :src="imgUrl" class="w-100">
                    </div>
                    <div>{{tagsStripped}}</div>
                </div>
                <SinglePriceInfo v-if="!adid"></SinglePriceInfo>
            </div>
        </div>
        <button class="btn btn-primary" type="button" v-if="adid" v-on:click.stop="saveState('save')">
            Salvesta kuulutuse andmed
        </button>
        <div v-else>
            <div class="col-md-12 p-0 text-center" v-html="$t('erisoovid')"></div>
            <a @click="onContinue" class="btn btn-primary btn-block"
                v-bind:class="{disabled: !formReady || store.isLoading}">
                <MoveForwardButton />
            </a>
        </div>
    </div>
</template>

<script setup>
import MoveForwardButton from './MoveForwardButton.vue';
import { onDeactivated, onMounted, watch, ref } from 'vue';
import { useMainStore } from '../includes/store';
import { QuillEditor, Quill } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { toast } from 'vue3-toastify';
import SinglePriceInfo from './SinglePriceInfo.vue';
import MyCropper from './MyCropper.vue';

const store = useMainStore();

const Block = Quill.import('blots/block');
Block.tagName = 'span';
Quill.register(Block, true);

const { t } = useI18n();

const props = defineProps({
    adid: { type: [String, Number], required: false },
    formReady: { type: Boolean, required: false }
});

const fileInput = ref(null);
const textAdContent = ref(null);
const quillEditor = ref(null);
const quillIndex = ref(0);
const watchOn = ref(true);
const category = ref(null);
const categories = ref([]);
const adContent = ref("");
const hasFrame = ref(false);
const hasBackground = ref(false);
const hasImage = ref(false);
const imageContent = ref(null);
const imgUrl = ref(null);
const originalImage = ref(null);
const wantTranslation = ref(true);
const translations = ref({
    'ru': "",
    'en': ""
});

const saveTimeout = ref(null);

const allowedFormats = ref([
    ["bold"], ["italic"]
]);
const customToolbar = ref([
    ["bold"], ["italic"], ['clean']
]);
const editorOptions = ref({
    modules: {
        clipboard: {
            matchVisual: false
        }
    }
});

onMounted(() => {
    loadState();
    loadCategories();
    categories.value = [];
})

onDeactivated(() => {
    saveState();
})

const removeParagraphs = () => {
    adContent.value = adContent.value.replace("<p>", "");
    adContent.value = adContent.value.replace("</p>", "");
    adContent.value = adContent.value.replace("<span>", "");
    adContent.value = adContent.value.replace("</span>", "");
}

const setQuillCursorLocation = () => {
    try {
        quillIndex.value = quillEditor.value.quill.getSelection().index + 3;
        if (adContent.value.substr(0, quillIndex.value).includes('<strong>')) {
            quillIndex.value = quillIndex.value + 8;
        }
        if (adContent.value.substr(0, quillIndex.value).includes('</strong>')) {
            quillIndex.value = quillIndex.value + 9;
        }
    } catch (e) {
        //works only when quill is actually active
    }
}

const addChar = (char) => {
    let textArea = textAdContent.value;
    let cursorLocation = 0;
    if (textArea) {
        cursorLocation = textArea.selectionStart;
        console.log(textArea.selectionStart, 'selstart');
    } else if (quillEditor.value) {
        cursorLocation = quillIndex.value;
        console.log("quillindex", cursorLocation);
    }
    console.log("Inserting symbol " + char + " to position " + cursorLocation);
    adContent.value = adContent.value.substr(0, cursorLocation) + char + adContent.value.substr(cursorLocation);
}

const getTranslationName = (key) => {
    if (key === "en") {
        return "inglise keeles";
    } else if (key === "ru") {
        return "vene keeles";
    }
    return "teadmata keeles";
}

const loadCategories = () => {
    axios.get('/api/categories').then(response => {
        categories.value = response.data;
    });
}

const saveState = async (saveNow, disableTimeout = false) => {
    if (!watchOn.value) {
        watchOn.value = true;
        return;
    }
    let postData = {
        category: category.value,
        adContent: tagsStripped.value,
        hasFrame: hasFrame.value === true,
        hasBackground: hasBackground.value === true,
        hasImage: hasImage.value === true,
        imgUrl: imgUrl.value,
        originalImage: originalImage.value,
        wantTranslation: wantTranslation.value === true,
        translations: translations.value,
    };

    if (saveTimeout.value) {
        clearTimeout(saveTimeout.value);
    }

    if (props.adid) {
        if (saveNow === "save") {
            axios.put('/admin/advertisement/' + props.adid + '/advertisement', postData).then(_ => {
                toast.info('Kuulutus salvestatud');
                location.reload() // to update translation status if needed
            }).catch(errors => {
                if (errors.response.status === 422) {
                    for (const errName in errors.response.data.errors) {
                        toast.error(errors.response.data.errors[errName][0]);
                    }
                } else {
                    store.sessExpired();
                    toast.error('Salvestamine ebaõnnestus');
                }
            });
        } else {
            console.log('not saving data');
        }
    } else {
        store.setAdvertisement(postData);

        if (disableTimeout) {
            store.setIsLoading(true);
            await axios.post('/state/advertisement', {
                state: postData
            }).catch(_ => {
                store.sessExpired();
            }).finally(() => {
                store.setIsLoading(false);
            });
        } else {
            saveTimeout.value = setTimeout(_ => {
                axios.post('/state/advertisement', {
                    state: postData
                }).catch(_ => {
                    store.sessExpired();
                });
            }, 2500);
        }
    }
}

const loadState = () => {
    if (props.adid) {
        axios.get('/admin/advertisement/' + props.adid + '/data').then(response => {
            setState(response.data);
        }).catch(_ => {
            store.sessExpired();
        })
    } else {
        let advertisement = store.stepInfo.content.advertisement;
        setState(advertisement)
    }
}

const setState = (advertisement) => {
    console.log("Loading advertisement state", advertisement);

    category.value = advertisement.category;
    if (typeof advertisement.adContent === "string") {
        if (adContent.value !== advertisement.adContent) {
            watchOn.value = false;
            adContent.value = advertisement.adContent;
        }   
    } else {
        adContent.value = "";
    }

    if (advertisement.translations && advertisement.translations.en == null) {
        advertisement.translations.en = "";
    }
    if (advertisement.translations && advertisement.translations.ru == null) {
        advertisement.translations.ru = "";
    }
    if (!advertisement.translations) {
        advertisement.translations = {
            'en': '',
            'ru': ''
        };
    }
    translations.value = advertisement.translations;

    hasFrame.value = advertisement.hasFrame;
    hasBackground.value = advertisement.hasBackground;
    hasImage.value = advertisement.hasImage;
    imgUrl.value = advertisement.imgUrl;
    imageContent.value = advertisement.originalImage;
    originalImage.value = advertisement.originalImage;
    if (Object.keys(translationNeeds.value).length === 0) {
        wantTranslation.value = false;
    } else {
        wantTranslation.value = advertisement.wantTranslation;
    }
}

const changed = (type) => {
    if (type === "frame" && hasFrame.value) {
        hasImage.value = false;
        hasBackground.value = false;
    } else if (type === "background" && hasBackground.value) {
        hasImage.value = false;
        hasFrame.value = false;
    } else if (type === "image" && hasImage.value) {
        hasBackground.value = false;
        hasFrame.value = false;
    }
    saveState();
}

const cropperCallback = (dataUrl, originalDataUrl) => {
    imgUrl.value = dataUrl;
    imageContent.value = originalDataUrl;
    originalImage.value = originalDataUrl;
    saveState();
}

function fileToDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onerror = () => {
      reader.abort()
      reject(new Error('Failed to read file'))
    }
    reader.onload = () => resolve(reader.result) // result is a data:... base64 string
    reader.readAsDataURL(file)
  })
}

const onFileChosen = async (event) => {
    const file = event.target.files && event.target.files[0]
    if (!file) return

    try {
        // convert to data URL (base64)
        const dataUrl = await fileToDataURL(file)
        imageContent.value = dataUrl
        event.target.value = '';
    } catch (err) {
        console.error('Could not read file as data URL', err)
    }
};

const tagsStripped = computed(() => {
    String.prototype.replaceAll = function (search, replacement) {
        var target = this;
        return target.replace(new RegExp(search, 'g'), replacement);
    };
    return adContent.value.replaceAll('<p>', "").replaceAll("</p>", "").replaceAll("<br>", "");
})

const previewClasses = computed(() => {
    return {
        adborder: hasFrame.value,
        adbackground: hasBackground.value,
        adimage: hasImage.value
    }
})

const translationNeeds = computed(() => {
    let needs = {};
    if (props.adid) {
        needs['ru'] = t("Tolge vene keeles");
        needs['en'] = t("Tolge inglise keeles");
        return needs;
    }

    return store.translationNeeds;
})

const onContinue = async () => {
    await saveState(false, true);
    store.changeStep('dates');
}

watch(() => adContent.value, () => {
    setQuillCursorLocation();
    saveState();
    removeParagraphs();
})

watch(() => store.stateLoaded, (loaded) => {
    if (loaded) {
        loadState();
    }
}, { immediate: true });

</script>

<style scoped>
    .preview {
        padding: 5px;
    }

    .adborder {
        border: solid 4px;
    }

    .adbackground {
        background: darkgrey;
    }

    :deep(.ql-editor) {
        min-height: 200px;
    }
</style>
